'use client';

import { c as _c } from "react/compiler-runtime";
import useProducts from '@shared/utils/hooks/useProducts';
import { Coins, HandCoins } from 'lucide-react';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import { client } from '../../utils/trpc';
import Modal, { ModalContent, ModalHeader } from '../HOC/Modal';
import CommunityPoolCard from '../products/CommunityPoolCard';
import PurchaseProducts from '../products/PurchaseProducts';
const DonationModal = dynamic(() => import('../common/DonationModal'), {
  ssr: false
});

// Small line under the research CTA telling the user who pays for the run, and
// a tap-through: pool-funded → donate to the pool (reusing the /products/my
// community-pool slider); self-funded → buy Trons (reusing the packages grid).
const ResearchCoverage = t0 => {
  const $ = _c(21);
  const {
    poolHasTrons
  } = t0;
  const {
    products
  } = useProducts(client);
  const [open, setOpen] = useState(false);
  const [donationModalOpen, setDonationModalOpen] = useState(false);
  const [donationAmountCents, setDonationAmountCents] = useState(500);
  let t1;
  if ($[0] !== products) {
    t1 = products.find(_temp);
    $[0] = products;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const donationProduct = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setOpen(true);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== poolHasTrons) {
    t3 = poolHasTrons ? <HandCoins className="size-3.5 text-primary" /> : <Coins className="size-3.5 text-primary" />;
    $[3] = poolHasTrons;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = poolHasTrons ? "Covered by the community Trons pool" : "Covered by your Trons";
  let t5;
  if ($[5] !== t4) {
    t5 = <span className="underline decoration-dotted underline-offset-2">{t4}</span>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t5) {
    t6 = <button onClick={t2} className="inline-flex items-center gap-1.5 text-xs text-textSecondary transition-colors hover:text-textPrimary">{t3}{t5}</button>;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== open || $[11] !== poolHasTrons) {
    t7 = open && <Modal closeHandler={() => setOpen(false)}><ModalHeader closeHandler={() => setOpen(false)}>{poolHasTrons ? "Community Trons pool" : "Your Trons"}</ModalHeader><ModalContent>{poolHasTrons ? <CommunityPoolCard onOpenDonation={amountCents => {
          setDonationAmountCents(amountCents);
          setDonationModalOpen(true);
        }} /> : <PurchaseProducts />}</ModalContent></Modal>;
    $[10] = open;
    $[11] = poolHasTrons;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== donationAmountCents || $[14] !== donationModalOpen || $[15] !== donationProduct) {
    t8 = donationModalOpen && <DonationModal key={donationAmountCents} closeHandler={() => setDonationModalOpen(false)} product={donationProduct} initialAmountCents={donationAmountCents} />;
    $[13] = donationAmountCents;
    $[14] = donationModalOpen;
    $[15] = donationProduct;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
    t9 = <>{t6}{t7}{t8}</>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
};
export default ResearchCoverage;
function _temp(product) {
  return product.type === "DONATION";
}